import { IUserDetail } from './../types/user'
import { IProject } from './../views/project/types/project'

/**
 * Check rights for given user.
 * Only enabled rights are considered - disabled rights are treated as if the user doesn't have them.
 */
export const checkRole = (user: IUserDetail, rights: number[]): boolean => {
  if (user.is_superuser || rights.length === 0) {
    return true
  } else {
    const employeeRights = user.employee
      ? user.employee.roles.flatMap(r => r.rights).filter(right => right.enabled)
      : []
    let hasAccess = false
    employeeRights.forEach(r => {
      if (rights.indexOf(+r.id) > -1) {
        hasAccess = true
      }
    })
    return hasAccess
  }
}

/***
 * Checks project admin status for given user and project.
*/
export const checkAdminStatus = (user: IUserDetail, project: IProject): boolean => {
  if (user.is_superuser) {
    return true
  } else {
    if (project.admins) {
      const _admins = project.admins.flatMap(a => +a.id)
      const employee_id = user.employee ? +user.employee.id : -1
      if (_admins.length > 0 && employee_id !== -1) {
        if (user.is_superuser || _admins.includes(employee_id)) {
          return true
        }
      }
    }
    return false
  }
}

/***
 * Checks project team member or admin status for given user and project.
*/
export const checkTeamMemberOrAdminStatus = (user: IUserDetail, project: IProject): boolean => {
  if (user.is_superuser) {
    return true
  } else {
    const employee_id = user.employee ? +user.employee.id : -1
    if (employee_id !== -1) {
      if (project.admins) {
        const _admins = project.admins.flatMap(a => +a.id)
        if (user.is_superuser || _admins.includes(employee_id)) {
          return true
        }
      }
      if (project.employees) {
        const _teamMembers = project.employees.flatMap(e => +e.id)
        if (user.is_superuser || _teamMembers.includes(employee_id)) {
          return true
        }
      }
    }
    return false
  }
}
